import { render, staticRenderFns } from "./PollingOption.vue?vue&type=template&id=0ba99e8e&scoped=true&"
import script from "./PollingOption.vue?vue&type=script&lang=js&"
export * from "./PollingOption.vue?vue&type=script&lang=js&"
import style0 from "./PollingOption.vue?vue&type=style&index=0&id=0ba99e8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba99e8e",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QSelect,QInput,QBtn});
